import React, { Component } from 'react';
import axios from 'axios';
import { Image } from 'pixboost-react';
import { Button } from 'reactstrap';
import pixboostConfig from '../../../config/pixboost';
import lodashGet from 'lodash.get';
import './ProductTile.css';

let miniCartControl;

class ProductTile extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  loadProduct() {
    this.setState({ error: undefined, loading: true });
    axios
      .get(`/api/v1/products/${this.props.sku}`)
      .then(response => response.data)
      .then(({ products }) => {
        const state = Object.assign(
          { loading: false },
          products && products.length > 0
            ? {
                name: products[0].identity.name,
                image: products[0].description.thumbnail,
                price: products[0].price.single
              }
            : null
        );
        this.setState(state);
      })
      .catch(err => {
        console.error(err);
        this.setState({ error: true, loading: false });
      });
  }
  componentDidMount() {
    this.loadProduct();
  }

  triggerAddToCartAnalytics(sku) {
    if (lodashGet(global, 'CustomEvent')) {
      const customEvent = new CustomEvent('add-to-cart-fra', {
        bubbles: true,
        detail: {
          addToCart: {
            Brand: true, // eVar36
            events: 'scAdd',
            product: [
              {
                productInfo: {
                  productID: sku,
                  qty: 1
                }
              }
            ]
          }
        }
      });
      const domElement = document.getElementById('dtmEventsDomElement');
      if (domElement !== null) {
        document
          .getElementById('dtmEventsDomElement')
          .dispatchEvent(customEvent);
      }
    }
  }

  addToCart(sku) {
    if (
      typeof window.ow !== 'undefined' &&
      typeof window.ow.controls !== 'undefined' &&
      typeof window.ow.controls.addtocartcontrol !== 'undefined' &&
      typeof miniCartControl === 'undefined'
    ) {
      miniCartControl = new window.ow.controls.addtocartcontrol({
        el: document.documentElement
      });
    }
    axios
      .get(
        `/webapp/wcs/stores/servlet/AjaxOrderChangeServiceItemAdd?nc=true&partNumber_1=${sku}&quantity_1=1`
      )
      .then(() => {
        if (typeof miniCartControl !== 'undefined') {
          miniCartControl.updateMiniCart();
        }
        const addtocartcontrol = new window.ow.controls.addtocartcontrol();
        addtocartcontrol.updateMiniCart();
        if (typeof window.$ === 'function') {
          window.$(document).trigger('alert', {
            type: 'success',
            html: '<strong>Item added to cart</strong>',
            dismissible: true,
            scrollTo: false,
            trackState: false,
            floating: true,
            timeout: 3000,
            insert: {
              method: 'prependTo',
              selector: 'main'
            }
          });

          this.triggerAddToCartAnalytics(sku);
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  render() {
    if (this.state.loading) {
      return <div className="ow-loading" style={{ height: '285px' }} />;
    }

    const { name, image, price } = this.state;
    if (!name || !image) {
      return null;
    }

    const { sku } = this.props;

    return (
      <div className={'product-tile'}>
        <div className="product-image-container">
          <a href={`/shop/officeworks/p/-${sku}`} title={name} target="_blank">
            <Image src={image} alt={name} config={pixboostConfig} />
          </a>
        </div>
        <div>
          <div className={'ow-price ow-price--smal'}>
            <span className="ow-price__amount">${price}</span>
          </div>
          <h3>
            <a
              href={`/shop/officeworks/p/-${sku}`}
              title={name}
              target="_blank"
            >
              {name}
            </a>
          </h3>
          <Button
            className={'btn btn-success btn-block ow-add-to-cart'}
            onClick={() => this.addToCart(sku)}
          >
            <span>Add to Cart</span>
          </Button>
        </div>
      </div>
    );
  }
}

export default ProductTile;



// WEBPACK FOOTER //
// ./src/components/content-blocks/LookBook/ProductTile.js